import { useWsmOptionSetListQuery } from "@dashboard/graphql";
import useLocalPaginator, { useLocalPaginationState } from "@dashboard/hooks/useLocalPaginator";
import { mapEdgesToItems } from "@dashboard/utils/maps";
import React, { useState } from "react";

import WsmOptionSetListPage from "../components/WsmOptionSetListPage/WsmOptionSetListPage";

const PAGINATE_BY = 20;

export const WsmOptionSetListView = () => {
  const [query, setQuery] = useState("");
  const [rowNumber, setRowNumber] = useState(PAGINATE_BY);
  const [paginationState, setPaginationState] = useLocalPaginationState(rowNumber);
  const paginate = useLocalPaginator(setPaginationState);
  const { data, loading } = useWsmOptionSetListQuery({
    variables: {
      ...paginationState,
      filter: query ? { search: query } : {},
    },
  });
  const { loadNextPage, loadPreviousPage, pageInfo } = paginate(
    data?.wsmOptionSets?.pageInfo,
    paginationState,
  );

  return (
    <WsmOptionSetListPage
      optionSets={loading ? undefined : (mapEdgesToItems(data?.wsmOptionSets) ?? [])}
      query={query}
      settings={{ rowNumber }}
      hasNextPage={pageInfo?.hasNextPage ?? false}
      hasPreviousPage={pageInfo?.hasPreviousPage ?? false}
      onQueryChange={value => {
        setQuery(value);
        setPaginationState({});
      }}
      onUpdateListSettings={(key, value) => {
        if (key === "rowNumber") {
          setRowNumber(value as number);
        }
      }}
      onNextPage={loadNextPage}
      onPreviousPage={loadPreviousPage}
    />
  );
};

export default WsmOptionSetListView;
